import Helpers from '../inc/Helpers';
import Ajax from '../inc/Ajax';

class Paginations {
    constructor() {
        this.helpers = new Helpers();
        this.ajax = new Ajax();

        this.cards = $('.ajax-scroll-to#cards');
    }

    init() {
        let self = this;

        self.scrollToResultsBlock();
        self.ajaxPagination();
        self.fontawesomePaginationBtns();
    }

    scrollToResultsBlock() {
        let self = this;

        let keyword = self.helpers.getURLQueryParam('r');
        let category = self.helpers.getURLQueryParam('categorie');
        let province = self.helpers.getURLQueryParam('province');
        let tab = self.helpers.getURLQueryParam('tab');
        
        if (keyword || category || province || tab) {
            self.doScrollToResultsBlock();
            self.fontawesomePaginationBtns();
        }
    }

    ajaxPagination() {
        let self = this;

        $('body').on('click', '.page-link', function (e) {
            e.preventDefault();

            let thisBtn = $(this);
            let paginatedUrl = thisBtn.attr('href');
            let resultsWrapper = $('.cards');
    
            if (!paginatedUrl) {
                return;
            }
    
            resultsWrapper.css('opacity', 0.3);
    
            const done = function (response) {
                resultsWrapper.html(response);
                window.history.pushState(null, null, paginatedUrl);
                self.doScrollToResultsBlock();

                $(window).on('popstate', function () {
                    let previousPageNumber = self.helpers.getURLQueryParam('page') ?? 1;
                    let currentUrl = window.location.href;

                    if (previousPageNumber === 1) {
                        currentUrl = self.helpers.appendQueryParameter(currentUrl, 'page', 1); 
                    }

                    let previousPageBtn = $('.page-link[href="' + currentUrl + '"]');

                    previousPageBtn.trigger('click');
                });
            };
    
            const fail = function () {
                window.location.href = paginatedUrl;
            };
    
            const always = function () {
                resultsWrapper.css('opacity', 1);
            };

            if ($('body').is('.announcements')) {
                $('body').find('.col-navigation .selected').attr('href', paginatedUrl);
            }
    
            self.ajax.get(paginatedUrl, 'HTML', {}, done, fail, always);
        });
    }

    doScrollToResultsBlock() {
        let self = this;

        self.helpers.scrollToElement('default', self.cards, -75);
        self.fontawesomePaginationBtns();
    }

    fontawesomePaginationBtns() {
        let previousButton = $('.page-link[rel=prev]');
        let nextButton = $('.page-link[rel=next]');

        previousButton.html('<i class="fas fa-chevron-left"></i>');
        nextButton.html('<i class="fas fa-chevron-right"></i>');
    }
}

export default Paginations;